import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GridFilterSelect } from './GridFilterSelect';
import { SupplierState } from '@api/models/enums/SupplierState';

const options = Object.values(SupplierState);

interface Props {
  value?: SupplierState;
  onChange: (value?: SupplierState) => void;
}

export const GridFilterSupplierState: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <GridFilterSelect
      value={value}
      options={options}
      onChange={onChange}
      getOptionId={(option: SupplierState) => option}
      getOptionName={(option: SupplierState) => t(`entityState.${option}`)}
    />
  );
};
